import React from 'react';
import { MarkerRecord } from '../../services/api';
import MarkedVideoTile from './MarkedVideoTile';
import MarkedSegmentTile from './MarkedSegmentTile';
import MarkedFieldTile from './MarkedFieldTile';
import MarkedRunTile from './MarkedRunTile';

export interface PreviewData {
  thumbnailUrl?: string;
  thumbnailGcsUri?: string;
  gifUrl?: string;
  gifGcsUri?: string;
  videoTitle?: string;
  segmentStartTime?: number;
  segmentEndTime?: number;
}

interface MarkedTileProps {
  record: MarkerRecord;
  previewData?: PreviewData;
  isHovered: boolean;
  onHover: (hovered: boolean) => void;
  onClick: () => void;
  onRemove: () => void;
  onMarkerChange: (next: MarkerRecord | null) => void;
}

const MarkedTile: React.FC<MarkedTileProps> = ({
  record,
  previewData,
  isHovered,
  onHover,
  onClick,
  onRemove,
  onMarkerChange,
}) => {
  const commonProps = {
    record,
    previewData,
    isHovered,
    onHover,
    onClick,
    onRemove,
    onMarkerChange,
  };

  switch (record.entity_type) {
    case 'video':
      return <MarkedVideoTile {...commonProps} />;
    case 'segment':
      return <MarkedSegmentTile {...commonProps} />;
    case 'metadata_field':
      return <MarkedFieldTile {...commonProps} />;
    case 'prompt_run':
      return <MarkedRunTile {...commonProps} />;
    default:
      return <MarkedSegmentTile {...commonProps} />;
  }
};

export default MarkedTile;
